<template>
    <base-nav
            v-model="showMenu"
            class="navbar-absolute top-navbar"
            :transparent="true"
    >
        <div slot="brand" class="navbar-wrapper">
            <div class="navbar-minimize d-inline">
                <sidebar-toggle-button/>
            </div>
            <div
                    class="navbar-toggle d-inline"
                    :class="{ toggled: $sidebar.showSidebar }"
            >
                <button type="button" class="navbar-toggler" @click="toggleSidebar">
                    <span class="navbar-toggler-bar bar1"></span>
                    <span class="navbar-toggler-bar bar2"></span>
                    <span class="navbar-toggler-bar bar3"></span>
                </button>
            </div>
            <a class="navbar-brand" href="#pablo">{{ routeName }}</a>
        </div>

        <ul class="navbar-nav" :class="$rtl.isRTL ? 'mr-auto' : 'ml-auto'">
            <!--            <div class="search-bar input-group" @click="searchModalVisible = true;">-->
            <!--                &lt;!&ndash;-->
            <!--                  <input type="text" class="form-control" placeholder="Search...">-->
            <!--                  <div class="input-group-addon"><i class="tim-icons icon-zoom-split"></i></div>-->
            <!--                &ndash;&gt;-->
            <!--                <button-->
            <!--                        class="btn btn-link"-->
            <!--                        id="search-button"-->
            <!--                        data-toggle="modal"-->
            <!--                        data-target="#searchModal"-->
            <!--                >-->
            <!--                    <i class="tim-icons icon-zoom-split"></i>-->
            <!--                </button>-->
            <!--                &lt;!&ndash; You can choose types of search input &ndash;&gt;-->
            <!--            </div>-->
            <!--            <modal-->
            <!--                    :show.sync="searchModalVisible"-->
            <!--                    class="modal-search"-->
            <!--                    id="searchModal"-->
            <!--                    :centered="false"-->
            <!--                    :show-close="true"-->
            <!--            >-->
            <!--                <input-->
            <!--                        slot="header"-->
            <!--                        v-model="searchQuery"-->
            <!--                        type="text"-->
            <!--                        class="form-control"-->
            <!--                        id="inlineFormInputGroup"-->
            <!--                        placeholder="SEARCH"-->
            <!--                />-->
            <!--            </modal>-->
            <base-dropdown
                    tag="li"
                    :menu-on-right="!$rtl.isRTL"
                    title-tag="a"
                    class="nav-item"
            >
                <a
                        slot="title"
                        href="#"
                        class=" nav-link"
                        data-toggle="dropdown"
                        style="    width: auto;
    display: inline-block;"
                >
                    <div class="notification d-none d-lg-block d-xl-block"></div>
                    <i class="tim-icons icon-sound-wave"></i>
                    <p class="d-lg-none">New Notifications</p>
                </a>
                <li class="nav-link">
                    <a href="#" class="nav-item dropdown-item"
                    >Mike John responded to your email</a
                    >
                </li>
                <li class="nav-link">
                    <a href="#" class="nav-item dropdown-item">You have 5 more tasks</a>
                </li>
                <li class="nav-link">
                    <a href="#" class="nav-item dropdown-item"
                    >Your friend Michael is in town</a
                    >
                </li>
                <li class="nav-link">
                    <a href="#" class="nav-item dropdown-item">Another notification</a>
                </li>
                <li class="nav-link">
                    <a href="#" class="nav-item dropdown-item">Another one</a>
                </li>
            </base-dropdown>
            <base-dropdown
                    tag="li"
                    :menu-on-right="!$rtl.isRTL"
                    title-tag="a"
                    class="nav-item"
                    menu-classes="dropdown-navbar"
            >
                <a
                        slot="title"
                        href="#"
                        class="nav-link"
                        data-toggle="dropdown"
                        aria-expanded="true"
                        style="    width: auto;
    display: inline-block;"
                >
                    <div class="photo"><img :src="logo"/></div>
                    <p class="d-lg-none">{{customerName}}</p>
                </a>
                <li class="nav-link">
                    <router-link to="/profile" class="nav-item dropdown-item" activeClass="actives">Profile
                    </router-link>
                </li>
                <div class="dropdown-divider"></div>
                <li class="nav-link">
                    <a v-on:click="logout" class="nav-item dropdown-item">Log out</a>
                </li>
            </base-dropdown>
        </ul>
    </base-nav>
</template>
<script>
    import {CollapseTransition} from 'vue2-transitions';
    import {BaseNav, Modal} from '@/components';
    import SidebarToggleButton from './SidebarToggleButton';
    import md5 from 'md5';

    export default {
        components: {
            SidebarToggleButton,
            CollapseTransition,
            BaseNav,
            Modal
        },
        computed: {
            routeName() {
                const {name} = this.$route;
                return this.capitalizeFirstLetter(name);
            },
            isRTL() {
                return this.$rtl.isRTL;
            },
            customerName() {
                return this.$store.getters['customer/name']
            },
            customerEmail() {
                return this.$store.getters['customer/email']
            },
            logo() {
                if (this.customerEmail === null) {
                    return;
                }
                return 'https://www.gravatar.com/avatar/' + md5(this.customerEmail) + 'https://ui-avatars.com/api/name=' + this.customerName + '200/1/true/true';
            },
        },
        data() {
            return {
                activeNotifications: false,
                showMenu: false,
                searchModalVisible: false,
                searchQuery: ''
            };
        },
        methods: {
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            toggleNotificationDropDown() {
                this.activeNotifications = !this.activeNotifications;
            },
            closeDropDown() {
                this.activeNotifications = false;
            },
            toggleSidebar() {
                this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
            },
            hideSidebar() {
                this.$sidebar.displaySidebar(false);
            },
            toggleMenu() {
                this.showMenu = !this.showMenu;
            },
            logout() {
                this.$store.dispatch('AUTH_LOGOUT').then((resp) => {
                    this.$router.push('/login')
                })
            }
        }
    };
</script>
<style scoped>
    .top-navbar {
        top: 0px;


    }

    @media (max-width: 991px) {
        .top-navbar.navbar-expand-lg {
            top: 0;
            box-shadow: 0 1rem 3rem rgba(44,34,62, .175) !important;
        }
    }

</style>
